module.exports = __webpack_public_path__ + "img/hexgon.a87e7aed.jpg";